import { NavSection } from "src/components/NavSection";
import { twMerge } from "tailwind-merge";
// import { useMenu } from "src/contexts/MenuContext";
import { HomeIcon, QuitIcon } from "src/components/ui-icons/menu";
import { handleLogout } from "src/utils/api.utils";
import { NavItemsType } from "./DashboardLayout";
import { useAppSelector } from "src/hooks/redux";
import { selectCurrentUser } from "src/modules/users/selector";
import Avatar from "src/components/ui/avatar";
import { useParams } from "react-router-dom";
import HelpIcon from "src/components/ui-icons/menu/HelpIcon";
import {
  MicrophoneIcon,
  QuestionIcon,
  FilePenIcon,
  MyTeamIcon,
} from "src/components/ui-icons/menu/myTasks";
import Audit5SIcon from "src/components/ui-icons/menu/myTasks/5sAudit";
import IncidentsIcon from "src/components/ui-icons/menu/Incidents";
import { useState } from "react";
import { Modal } from "src/components/DialogComponent";
import { getSafeAreaTopPaddingCss } from "src/utils/mobile";

const getMobileNavigation = (
  id: string | undefined,
  hasTeam: boolean
): NavItemsType | null => {
  if (!id) return null;
  // Мобильное меню для "Мои задачи" (system id = "3") по макету
  if (id === "3") {
    const myTeamItem: NavItemsType[number] = {
      name: "Моя команда",
      url: `/dashboard/${id}/my-team`,
      icon: <MyTeamIcon />,
    };
    const items: NavItemsType = [
      { name: "Главная", url: `/dashboard/${id}`, icon: <HomeIcon /> },
      ...(hasTeam ? [myTeamItem] : []),
      {
        name: "Совещания",
        url: `/dashboard/${id}/meetings`,
        icon: <MicrophoneIcon />,
      },
      {
        name: "5Почему",
        url: `/dashboard/${id}/5-whys`,
        icon: <QuestionIcon />,
      },
      {
        name: "5S Аудит",
        url: `/dashboard/${id}/5S-audit`,
        icon: <Audit5SIcon />,
      },
      {
        name: "Поведенческий аудит (SBO)",
        url: `/dashboard/${id}/behavioral-audit`,
        icon: <FilePenIcon />,
      },
      {
        name: (
          <div className="flex flex-col leading-tight whitespace-normal">
            <span>Инциденты и несоответствия</span>
          </div>
        ),
        url: `/dashboard/${id}/incidents-and-nonconformities`,
        icon: <IncidentsIcon />,
      },
    ];
    return items;
  }
  return null;
};

const mobileExtraNavigations = (id?: string): NavItemsType => [
  {
    name: "Помощь",
    url: id ? `/dashboard/${id}/help` : "/help",
    icon: <HelpIcon />,
  },
];

export default function MobileMenu({
  list,
  open,
}: {
  list: NavItemsType;
  open: boolean;
}) {
  const currentUser = useAppSelector(selectCurrentUser);
  const { id } = useParams();
  const hasTeam =
    !!currentUser &&
    Object.keys(currentUser).length > 0 &&
    !!currentUser.id &&
    !!currentUser.reports &&
    currentUser.reports.length > 0;
  const customList = getMobileNavigation(id, hasTeam);
  const links = customList ?? list.filter(item => item.name !== "Отчеты");
  const [openLogoutConfirm, setOpenLogoutConfirm] = useState(false);
  const menuPaddingTop = getSafeAreaTopPaddingCss(68);

  return (
    <div
      className={twMerge(
        open ? "translate-x-0 hidden-body-scroll" : "-translate-x-full",
        "fixed mobile-menu z-30 top-0 left-0 w-full h-full bg-white transform transition-transform duration-300"
      )}
    >
      <div
        className="w-full sm:container px-10 max-md:px-6 mx-auto text-[14px] text-[#637381]"
        style={{ paddingTop: menuPaddingTop }}
      >
        <div className="flex flex-col divide-y sss">
          <NavSection links={links} />

          <NavSection links={mobileExtraNavigations(id)} />

          <div className="flex flex-row pt-2.5 items-center justify-between">
            <div className="flex flex-row items-center gap-2.5">
              <Avatar />
              <div className="flex flex-col text-black text-[14px] leading-[18px]">
                {currentUser.fullName}
                <span className="text-[#637381] text-[12px]">
                  {currentUser.jobTitleStr}
                </span>
              </div>
            </div>
            <div className="flex flex-col">
              <button
                type="button"
                onClick={() => setOpenLogoutConfirm(true)}
                className="menu-button relative flex justify-center items-center rounded-lg w-10 h-10 button-state"
              >
                <QuitIcon />
              </button>
            </div>
          </div>
        </div>
      </div>

      <Modal
        zIndex={80}
        open={openLogoutConfirm}
        toggleDialog={setOpenLogoutConfirm}
        modalClassName="w-[85vw] mx-auto min-h-0 sm:max-w-[420px]"
        hideXMarkIcon
        closeOnBackdrop
      >
        <div className="px-6 pb-4">
          <h2 className="text-[16px] font-semibold text-black">
            Подтвердите действие
          </h2>
        </div>

        <div className="px-6 pb-4 grow text-[14px] text-black">
          <p>Вы уверены, что хотите выйти из системы?</p>
        </div>

        <div className="flex flex-col gap-3 px-6">
          <button
            type="button"
            className="w-full py-3 rounded-md bg-darkblue text-white"
            onClick={() => {
              setOpenLogoutConfirm(false);
              handleLogout();
            }}
          >
            Да, выйти
          </button>
          <button
            type="button"
            className="w-full py-3 rounded-md bg-white border border-[#DFE4EA]"
            onClick={() => setOpenLogoutConfirm(false)}
          >
            Отмена
          </button>
        </div>
      </Modal>
    </div>
  );
}
